var React = require('react');

function BgInline (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("g",{"key":0},React.createElement("path",{"fill":"#dc458b","d":"M24.5 58C38.031 58 49 47.031 49 33.5S38.031 9 24.5 9 0 19.969 0 33.5 10.969 58 24.5 58z"})),React.createElement("g",{"key":1},React.createElement("path",{"fill":"#dc458b","d":"M99.5 25c6.904 0 12.5-5.596 12.5-12.5S106.404 0 99.5 0 87 5.596 87 12.5 92.596 25 99.5 25z"})),React.createElement("g",{"key":2},React.createElement("path",{"d":"M152.5 58c6.904 0 12.5-5.596 12.5-12.5S159.404 33 152.5 33 140 38.596 140 45.5 145.596 58 152.5 58z"}))]));
}

BgInline.defaultProps = {"width":"165","height":"58","viewBox":"0 0 165 58"};

module.exports = BgInline;

BgInline.default = BgInline;
